module.exports = __webpack_public_path__ + "media/images/groups-b9a497e7be5aab16d47a08142b71cfff.svg";